<template>
  <div class="digital-article-view "
    :class="{ 'digital-article-view-mobile': isMobile, 'digital-article-view-share': isShare }"
    :style="{ width: width.toString().indexOf('%') === -1 ? width + 'px' : width }" v-if="show" v-singletap="click">
    <div class="top">
      <div class="txt" v-if="isMobile && !isShare">文章</div>
      <div class="close" @click="close" v-show="initShowClose">
        <img src="@imgs/digital/close-black.png" />
      </div>
      <div class="back" @click="back" v-show="initShowBack">
        <img src="@imgs/digital/to-paper.png" />
      </div>
    </div>
    <div class="box" id="digital-article-view-box" @touchstart="boxTouchstart" @touchmove="boxTouchmove">
      <div class="text" id="digital-article-view-box-text" :class="{ currentClassName: true, 'no-copy': copyText === 0 }" v-dbtap="readSentence" v-html="articleText"></div>
    </div>
    <div class="bottom">
      <div class="line"></div>
      <div class="btn prev" @click="prev" v-show="initShowPrevAndNext">
        <img src="@imgs/digital/prev-black.png" />
      </div>
      <div class="btn a-" @click="narrow">A-</div>
      <div class="btn a" @click="normal">A</div>
      <div class="btn a+" @click="enlarge">A+</div>
      <div class="btn read" @click="read" v-if="audioSrc">
        <img src="@imgs/digital/read-black-ani.gif" v-if="readStatus" />
        <img src="@imgs/digital/read-black.png" v-else />
      </div>
      <div class="btn read" @click="changeAudioSpeed" v-if="audioSrc">
        <img v-if="currentSpeed === 1" src="@imgs/listen/speed.png"/>
        <img v-else-if="currentSpeed === 1.5" src="@imgs/listen/speed-fast.png"/>
        <img v-else-if="currentSpeed === 0.8" src="@imgs/listen/speed-slow.png"/>
      </div>
      <div class="btn next" @click="next" v-show="initShowPrevAndNext">
        <img src="@imgs/digital/next-black.png" />
      </div>
    </div>
    <audio ref="sentenceAudio" v-if="sentenceRead === 1" :src="audioSrc" id="articleSentenceAudio" @play="readStatus = true" @pause="readStatus = false" @ended="sentenceEnd" />
    <audio ref="audio" v-else :src="audioSrc" id="articleAudio" @play="readStatus = true" @pause="readStatus = false" @ended="readStatus = false" />
  </div>
</template>
<script>
import { isLogin, convertEnName } from '@/utils'
import homeApi from '@api/home'
export default {
  name: 'DigitalArticleView',
  components: {},
  props: {
    width: {
      type: [Number, String],
      default: 400
    },
    isShare: {
      type: Boolean,
      default: false
    },
    initShow: {
      type: Boolean,
      default: false
    },
    initShowBack: {
      type: Boolean,
      default: false
    },
    initShowClose: {
      type: Boolean,
      default: true
    },
    initShowPrevAndNext: {
      type: Boolean,
      default: true
    },
    initShowToPaper: {
      type: Boolean,
      default: true
    },
    epaperId: {
      type: String,
      default: ''
    },
    initArticleText: {
      type: String,
      default: ''
    },
    audioSrc: {
      default: null
    }
  },
  data() {
    return {
      show: this.initShow,
      articleText: this.initArticleText,
      currentClassIndex: 0,
      currentClassName: '',
      box: null,
      boxY: 0,
      boxTouchY: 0,
      voices: ['x3_guange', 'x4_lingxiaoying_en', 'x2_wanshu', 'xiaoyan', 'aisjiuxu', 'aisxping', 'aisjinger', 'aisbabyxu'],
      readStatus: false,
      isCollect: false,
      collectId: false,
      title: '',
      articleId: '',
      creator: '',
      currentSpeed: 1,
      sentenceIndex: 0
    }
  },
  watch: {
    initShow(show) {
      this.show = show
      this.initArticleStyle()
    },
    initArticleText(articleText) {
      this.articleText = articleText
      this.loadFtfont()
      this.initArticleStyle()
      this.readStatus = false
      this.pause()
    }
  },
  computed: {
    isMobile() {
      return this.$store.state.book.isMobile
    },
    voiceNumber() {
      return this.$route.query.voiceNumber && this.$route.query.voiceNumber !== '' ? this.$route.query.voiceNumber : this.$store.state.config.bookObj.voiceNumber
    },
    sentenceRead() {
      return this.$store.state.book.bookData.sentenceRead
    },
    copyText() {
      return this.$store.state.book.bookData?.copyText
    },
    timer() {
      return this.$store.state.book.timer
    },
    displayOrNot() {
      return this.$store.state.config.bookObj.displayOrNot
    },
    userName() {
      return localStorage.getItem('username')
    }
  },
  mounted() {
  },
  methods: {
    initArticleStyle() {
      this.$nextTick(() => {
        let abstracts = document.getElementsByClassName('content_type_0004')
        if (abstracts && abstracts.length > 0) {
          let last = abstracts[abstracts.length - 1]
          last.style['border-bottom'] = '1px dotted #777777'
        }
      })
    },
    boxTouchstart(e) {
      // this.box = document.getElementById('digital-article-view-box')
      // this.boxY = this.box.scrollTop
      // this.boxTouchY = e.touches[0].pageY
    },
    boxTouchmove(e) {
      // this.box.scrollTop = this.boxTouchY - e.touches[0].pageY + this.boxY
    },
    click(e) {
      if (this.isMobile && e.type === 'singletap' && e.target.className.indexOf('fd-js-excludes') < 0) {
        clearTimeout(this.timer)
        // this.$store.commit('book/UPDATE_IS_SHOW_FOOTER', false)
        // this.$store.commit('book/UPDATE_IS_SHOW_TITLE', false)
      }
    },
    readSentence(e) {
      if (this.sentenceRead && this.readStatus) {
        $('.current-play').removeClass('current-play')
        let htmlDiv = e.target
        let attrSrc = htmlDiv.getAttribute('src')
        if (attrSrc) {
          this.sentenceIndex = parseInt(htmlDiv.getAttribute('index'))
          this.$refs.sentenceAudio.pause()
          this.$refs.sentenceAudio.currentTime = 0
          this.$refs.sentenceAudio.src = attrSrc
          this.$refs.sentenceAudio.play()
          this.$refs.sentenceAudio.playbackRate = this.currentSpeed
          htmlDiv.className = 'current-play'
        }
      }
    },
    sentenceEnd() {
      $('.current-play').removeClass('current-play')
      this.sentenceIndex++
      let currentHtml = document.getElementById('sentence' + this.sentenceIndex)
      if (currentHtml === null) {
        this.$refs.sentenceAudio.currentTime = 0
        this.sentenceIndex = 0
        this.readStatus = false
        this.$refs.sentenceAudio.src = this.audioSrc
        return
      }
      this.readStatus = true
      this.$refs.sentenceAudio.src = currentHtml.getAttribute('src')
      this.$refs.sentenceAudio.currentTime = 0
      this.$refs.sentenceAudio.play()
      this.$refs.sentenceAudio.playbackRate = this.currentSpeed
      currentHtml.className = 'current-play'
    },
    share() {
      this.$emit('onShare')
    },
    close() {
      this.show = false
      this.readStatus = false
      this.pause()
      this.$emit('onClose')
    },
    back() {
      this.show = false
      this.$emit('onBack')
    },
    prev() {
      this.$emit('onPrev')
      setTimeout(() => {
        this.box = document.getElementById('digital-article-view-box')
        this.box.scrollTop = 0
      }, 500)
    },
    narrow() {
      this.currentClassIndex -= 2
      if (this.currentClassIndex < -10) {
        this.currentClassIndex = -10
      }
      if (this.currentClassIndex < 0) {
        this.currentClassName = 'text__' + Math.abs(this.currentClassIndex)
      } else if (this.currentClassIndex === 0) {
        this.currentClassName = ''
      } else if (this.currentClassIndex > 0) {
        this.currentClassName = 'text_' + this.currentClassIndex
      }
    },
    normal() {
      this.currentClassIndex = 0
      this.currentClassName = ''
    },
    enlarge() {
      this.currentClassIndex += 2
      if (this.currentClassIndex > 10) {
        this.currentClassIndex = 10
      }
      if (this.currentClassIndex < 0) {
        this.currentClassName = 'text__' + Math.abs(this.currentClassIndex)
      } else if (this.currentClassIndex === 0) {
        this.currentClassName = ''
      } else if (this.currentClassIndex > 0) {
        this.currentClassName = 'text_' + this.currentClassIndex
      }
    },
    next() {
      this.$emit('onNext')
      setTimeout(() => {
        this.box = document.getElementById('digital-article-view-box')
        this.box.scrollTop = 0
      }, 500)
    },
    read() {
      const audio = this.sentenceRead === 1 ? this.$refs.sentenceAudio : this.$refs.audio
      if (this.readStatus) {
        audio.pause()
        audio.currentTime = 0
        audio.src = this.audioSrc
        this.sentenceIndex = 0
        this.readStatus = false
        $('.current-play').removeClass('current-play')
      } else {
        audio.playbackRate = this.currentSpeed
        audio.play()
        if (this.sentenceRead === 1) {
          document.getElementById('sentence' + this.sentenceIndex).className = 'current-play'
        }
      }
    },
    pause() {
      if (this.$refs.audio) {
        this.$refs.audio.pause()
        this.$refs.audio.currentTime = 0
      }
      if (this.$refs.sentenceAudio) {
        this.$refs.sentenceAudio.pause()
        this.$refs.sentenceAudio.currentTime = 0
        this.sentenceIndex = 0
        $('.current-play').removeClass('current-play')
      }
    },
    loadFtfont() {
      // 加载方正云字体
      let script = document.createElement('script')
      script.type = 'text/javascript'
      script.src = 'https://cdn1.foundertype.com/webfont/js/ftfont-init.js'
      script.onload = () => {
        // 设置字体
        let fontCfg = {
          p: 'rIgV4ZlDZrprpbtH',
          fonts: [
            {
              // 方正悠宋 GBK 509R
              fontName: 'FZYouSK_509R',
              selecters: ['.content_type_0001', '.content_type_0003', '.content_type_0008']
            },
            {
              // 方正悠黑_GBK 511M
              fontName: 'FZYouHK_511M',
              selecters: ['.content_type_0002']
            },
            {
              // 方正悠宋 GBK 507R
              fontName: 'FZYouSK_507R',
              selecters: ['.content_type_0004', '.content_type_0005', '.content_type_0006', '.content_type_0007']
            }
          ]
        }
        setTimeout(() => {
          new FTFont(fontCfg)
        }, 1000)
      }
      document.body.appendChild(script)
    },
    changeAudioSpeed() {
      this.currentSpeed = this.currentSpeed === 1 ? 1.5 : this.currentSpeed === 1.5 ? 0.8 : 1
      this.$refs[ this.sentenceRead === 1 ? 'sentenceAudio' : 'audio'].playbackRate = this.currentSpeed
    },
  }
}
</script>
<style lang="scss">
.digital-article-view {
  position: absolute;
  right: 0;
  top: 0;
  height: 100%;
  background: #f3f3f3;
  z-index: 999;

  .top {
    position: relative;
    height: 50px;

    .txt {
      display: block;
      width: 100%;
      line-height: 40px;
      text-align: center;
      color: #3a3a3a;
      font-weight: bold;
      font-size: 16px;
    }

    .share {
      text-align: center;
      cursor: pointer;

      img {
        margin-top: 12px;
        width: 26px;
        height: 26px;
      }
    }

    .hide-close {
      right: 0;
    }

    .close {
      position: absolute;
      top: 0;
      right: 0;
      width: 50px;
      height: 50px;
      text-align: center;
      cursor: pointer;

      img {
        margin-top: 12px;
        width: 26px;
        height: 26px;
      }
    }

    .back {
      position: absolute;
      top: 0;
      left: 0;
      width: 106px;
      margin-left: 10px;
      height: 50px;
      text-align: center;
      cursor: pointer;
      display: flex;
      align-items: center;

      span {
        color: #3a3a3a;
        font-size: 16px;
      }

      img {
        width: 100%;
      }
    }

    .top-btn-group {
      position: absolute;
      top: 0;
      right: 43px;
      min-width: 100px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
    }

    .login {
      cursor: pointer;
      height: 30px;
      margin-right: 10px;

      img {
        height: 30px;
      }
    }

    .collect {
      cursor: pointer;
      margin-right: 10px;

      img {
        width: 26px;
      }
    }
  }

  .box {
    word-wrap: break-word;
    overflow: auto;
    height: calc(100% - 95px);
    padding: 0 15px 0 15px;
    font-size: 14px;

    .text {
      -webkit-user-select: text !important;
      -moz-user-select: text !important;
      -ms-user-select: text !important;
      user-select: text !important;
      font-size: 16px;
      line-height: 29px;
      &.no-copy {
        -webkit-user-select: none !important;
        -moz-user-select: none !important;
        -ms-user-select: none !important;
        user-select: none !important;
      }
      img {
        /* 全局图片 */
        display: block !important;
        margin: auto !important;
        max-width: 100% !important;
      }

      audio {
        /* 全局音频 */
        max-width: 100% !important;
      }

      video {
        /* 全局视频 */
        display: block !important;
        margin: auto !important;
        max-width: 100% !important;
      }

      .content_audio {
        /* 音频元素独立样式控制 */
        display: block !important;
        margin: auto !important;
        width: 100% !important;
        background: #f3f3f3 !important;
        font-size: 0 !important;
        line-height: 0 !important;
      }

      .content_type_0001 {
        /* 引题 */
        font-size: 16px !important;
        line-height: 28px !important;
        text-align: justify;
        color: #777777 !important;
      }

      .content_type_0002 {
        /* 标题 */
        font-size: 22px !important;
        line-height: 34px !important;
        text-align: justify;
        color: #000000 !important;
      }

      .content_type_0003 {
        /* 副标题 */
        font-size: 16px !important;
        line-height: 28px !important;
        text-align: justify;
        color: #777777 !important;
        margin-top: 20px;
      }

      .content_type_0004 {
        /* 摘要 */
        font-size: 16px !important;
        line-height: 28px !important;
        text-align: justify;
        color: #000000 !important;
        text-indent: 0.8em;
        margin: 20px 0 !important;
        padding-top: 5px !important;
        padding-bottom: 5px !important;

        &:first-of-type {
          border-top: 1px dotted #777777 !important;
        }

        &:last-of-type {
          border-bottom: 1px dotted #777777 !important;
        }
      }

      .content_type_0005 {
        /* 作者 */
        font-size: 14px !important;
        line-height: 22px !important;
        text-align: left;
        color: #777777 !important;
        margin-top: 20px;
      }

      .content_type_0006 {
        /* 图片说明 */
        font-size: 14px !important;
        line-height: 22px !important;
        text-align: center;
        color: #777777 !important;
      }

      .content_type_0007 {
        /* 内容 */
        font-size: 16px !important;
        line-height: 29px !important;
        text-align: justify;
        color: #000000 !important;
        text-indent: 2em;
        margin-top: 20px;
        img {
          display: inline !important;
          height: 16px;
        }
      }

      .content_type_0008 {
        /* 小标题 */
        font-size: 16px !important;
        line-height: 29px !important;
        text-align: justify;
        color: #000000 !important;
        margin: 12px 0 !important;
      }
    }

    .text_2 {
      font-size: 18px;
      line-height: 31px;

      .content_type_0001 {
        font-size: 18px !important;
        line-height: 30px !important;
      }

      .content_type_0002 {
        font-size: 24px !important;
        line-height: 36px !important;
      }

      .content_type_0003 {
        font-size: 18px !important;
        line-height: 30px !important;
      }

      .content_type_0004 {
        font-size: 18px !important;
        line-height: 30px !important;
      }

      .content_type_0005 {
        font-size: 16px !important;
        line-height: 24px !important;
      }

      .content_type_0006 {
        font-size: 16px !important;
        line-height: 24px !important;
      }

      .content_type_0007 {
        font-size: 18px !important;
        line-height: 31px !important;
        img {
          display: inline !important;
          height: 18px;
        }
      }

      .content_type_0008 {
        font-size: 18px !important;
        line-height: 31px !important;
      }
    }

    .text_4 {
      font-size: 20px;
      line-height: 33px;

      .content_type_0001 {
        font-size: 20px !important;
        line-height: 32px !important;
      }

      .content_type_0002 {
        font-size: 26px !important;
        line-height: 38px !important;
      }

      .content_type_0003 {
        font-size: 20px !important;
        line-height: 32px !important;
      }

      .content_type_0004 {
        font-size: 20px !important;
        line-height: 32px !important;
      }

      .content_type_0005 {
        font-size: 18px !important;
        line-height: 26px !important;
      }

      .content_type_0006 {
        font-size: 18px !important;
        line-height: 26px !important;
      }

      .content_type_0007 {
        font-size: 20px !important;
        line-height: 33px !important;
        img {
          display: inline !important;
          height: 20px;
        }
      }

      .content_type_0008 {
        font-size: 20px !important;
        line-height: 33px !important;
      }
    }

    .text_6 {
      font-size: 22px;
      line-height: 35px;

      .content_type_0001 {
        font-size: 22px !important;
        line-height: 34px !important;
      }

      .content_type_0002 {
        font-size: 28px !important;
        line-height: 40px !important;
      }

      .content_type_0003 {
        font-size: 22px !important;
        line-height: 34px !important;
      }

      .content_type_0004 {
        font-size: 22px !important;
        line-height: 34px !important;
      }

      .content_type_0005 {
        font-size: 20px !important;
        line-height: 28px !important;
      }

      .content_type_0006 {
        font-size: 20px !important;
        line-height: 28px !important;
      }

      .content_type_0007 {
        font-size: 22px !important;
        line-height: 35px !important;
        img {
          display: inline !important;
          height: 22px;
        }
      }

      .content_type_0008 {
        font-size: 22px !important;
        line-height: 35px !important;
      }
    }

    .text_8 {
      font-size: 24px;
      line-height: 37px;

      .content_type_0001 {
        font-size: 24px !important;
        line-height: 36px !important;
      }

      .content_type_0002 {
        font-size: 30px !important;
        line-height: 42px !important;
      }

      .content_type_0003 {
        font-size: 24px !important;
        line-height: 36px !important;
      }

      .content_type_0004 {
        font-size: 24px !important;
        line-height: 36px !important;
      }

      .content_type_0005 {
        font-size: 22px !important;
        line-height: 30px !important;
      }

      .content_type_0006 {
        font-size: 22px !important;
        line-height: 30px !important;
      }

      .content_type_0007 {
        font-size: 24px !important;
        line-height: 37px !important;
        img {
          display: inline !important;
          height: 24px;
        }
      }

      .content_type_0008 {
        font-size: 24px !important;
        line-height: 37px !important;
      }
    }

    .text_10 {
      font-size: 26px;
      line-height: 39px;

      .content_type_0001 {
        font-size: 26px !important;
        line-height: 38px !important;
      }

      .content_type_0002 {
        font-size: 32px !important;
        line-height: 44px !important;
      }

      .content_type_0003 {
        font-size: 26px !important;
        line-height: 38px !important;
      }

      .content_type_0004 {
        font-size: 26px !important;
        line-height: 38px !important;
      }

      .content_type_0005 {
        font-size: 24px !important;
        line-height: 32px !important;
      }

      .content_type_0006 {
        font-size: 24px !important;
        line-height: 32px !important;
      }

      .content_type_0007 {
        font-size: 26px !important;
        line-height: 39px !important;
        img {
          display: inline !important;
          height: 26px;
        }
      }

      .content_type_0008 {
        font-size: 26px !important;
        line-height: 39px !important;
      }
    }

    .text__2 {
      font-size: 14px;
      line-height: 27px;

      .content_type_0001 {
        font-size: 14px !important;
        line-height: 26px !important;
      }

      .content_type_0002 {
        font-size: 20px !important;
        line-height: 32px !important;
      }

      .content_type_0003 {
        font-size: 14px !important;
        line-height: 26px !important;
      }

      .content_type_0004 {
        font-size: 14px !important;
        line-height: 26px !important;
      }

      .content_type_0005 {
        font-size: 12px !important;
        line-height: 20px !important;
      }

      .content_type_0006 {
        font-size: 12px !important;
        line-height: 20px !important;
      }

      .content_type_0007 {
        font-size: 14px !important;
        line-height: 27px !important;
        img {
          display: inline !important;
          height: 14px;
        }
      }

      .content_type_0008 {
        font-size: 14px !important;
        line-height: 27px !important;
      }
    }

    .text__4 {
      font-size: 12px;
      line-height: 25px;

      .content_type_0001 {
        font-size: 12px !important;
        line-height: 24px !important;
      }

      .content_type_0002 {
        font-size: 18px !important;
        line-height: 30px !important;
      }

      .content_type_0003 {
        font-size: 12px !important;
        line-height: 24px !important;
      }

      .content_type_0004 {
        font-size: 12px !important;
        line-height: 24px !important;
      }

      .content_type_0005 {
        font-size: 10px !important;
        line-height: 18px !important;
      }

      .content_type_0006 {
        font-size: 10px !important;
        line-height: 18px !important;
      }

      .content_type_0007 {
        font-size: 12px !important;
        line-height: 25px !important;
        img {
          display: inline !important;
          height: 12px;
        }
      }

      .content_type_0008 {
        font-size: 12px !important;
        line-height: 25px !important;
      }
    }

    .text__6 {
      font-size: 10px;
      line-height: 23px;

      .content_type_0001 {
        font-size: 10px !important;
        line-height: 22px !important;
      }

      .content_type_0002 {
        font-size: 16px !important;
        line-height: 28px !important;
      }

      .content_type_0003 {
        font-size: 10px !important;
        line-height: 22px !important;
      }

      .content_type_0004 {
        font-size: 10px !important;
        line-height: 22px !important;
      }

      .content_type_0005 {
        font-size: 8px !important;
        line-height: 16px !important;
      }

      .content_type_0006 {
        font-size: 8px !important;
        line-height: 16px !important;
      }

      .content_type_0007 {
        font-size: 10px !important;
        line-height: 23px !important;
        img {
          display: inline !important;
          height: 10px;
        }
      }

      .content_type_0008 {
        font-size: 10px !important;
        line-height: 23px !important;
      }
    }

    .text__8 {
      font-size: 8px;
      line-height: 21px;

      .content_type_0001 {
        font-size: 8px !important;
        line-height: 20px !important;
      }

      .content_type_0002 {
        font-size: 14px !important;
        line-height: 26px !important;
      }

      .content_type_0003 {
        font-size: 8px !important;
        line-height: 20px !important;
      }

      .content_type_0004 {
        font-size: 8px !important;
        line-height: 20px !important;
      }

      .content_type_0005 {
        font-size: 6px !important;
        line-height: 14px !important;
      }

      .content_type_0006 {
        font-size: 6px !important;
        line-height: 14px !important;
      }

      .content_type_0007 {
        font-size: 8px !important;
        line-height: 21px !important;
        img {
          display: inline !important;
          height: 8px;
        }
      }

      .content_type_0008 {
        font-size: 8px !important;
        line-height: 21px !important;
      }
    }

    .text__10 {
      font-size: 6px;
      line-height: 19px;

      .content_type_0001 {
        font-size: 6px !important;
        line-height: 18px !important;
      }

      .content_type_0002 {
        font-size: 12px !important;
        line-height: 24px !important;
      }

      .content_type_0003 {
        font-size: 6px !important;
        line-height: 18px !important;
      }

      .content_type_0004 {
        font-size: 6px !important;
        line-height: 18px !important;
      }

      .content_type_0005 {
        font-size: 4px !important;
        line-height: 12px !important;
      }

      .content_type_0006 {
        font-size: 4px !important;
        line-height: 12px !important;
      }

      .content_type_0007 {
        font-size: 6px !important;
        line-height: 19px !important;
        img {
          display: inline !important;
          height: 6px;
        }
      }

      .content_type_0008 {
        font-size: 6px !important;
        line-height: 19px !important;
      }
    }
  }

  .bottom {
    position: relative;
    display: flex;
    height: 45px;
    bottom: 0;

    .line {
      position: absolute;
      top: 0;
      left: 6%;
      width: 88%;
      height: 1px;
      background: #e3e3e3;
    }

    .btn {
      flex: 1;
      text-align: center;
      line-height: 45px;
      font-size: 24px;
      cursor: pointer;

      img {
        margin-top: 10px;
        width: 26px;
        height: 26px;
      }
    }
  }
  span {
    &.current-play {
      background-color: #FFE596;
      border-radius: 4px;
    }
  }
}

.digital-article-view-mobile {
  z-index: 9999;
  background: #ffffff;

  .top {
    background: #f5f5f5;
    height: 40px;

    .close {
      width: 40px;
      height: 40px;

      img {
        margin-top: 7px;
      }
    }

    .back {
      width: 100px;
      height: 40px;
      text-align: left;
      line-height: 40px;

      img {
        margin-right: 3px;
        margin-top: 0;
      }

      span {
        line-height: 40px;
      }
    }

    .top-btn-group {
      right: 0;
      height: 40px;
    }
  }

  .box {
    padding-top: 10px;
    padding-bottom: 10px;
    height: calc(100% - 85px);
  }
}

.digital-article-view-share {
  z-index: 9999;
  background: #f3f3f3;

  .box {
    padding-top: 10px;
    padding-bottom: 10px;
    height: calc(100% - 95px);
  }
}

.video-js {
  margin: auto;
}
</style>
<style>
.content_type_0004:not(.content_type_0004 ~ .content_type_0004) {
  /* 摘要 */
  border-top: 1px dotted #777777 !important;
}

.content_type_0004:last-of-type {
  /* 摘要 */
  border-bottom: 1px dotted #777777 !important;
}
</style>
